import { NotificationType } from "types/notification"

export const UPDATE_EVERY = 30;

export const ITEMS_PER_PAGE = 4;

export const literallyStatuses: {[key: number]: string} = {
  [-1]: "Все",
  0: "УМП",
  1: "Видео",
  2: "Пассажиропоток",
  3: "ПБК",
  4: "Мониторинг"
};